var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8297_44112)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 4.16742V2.67576C10.0007 2.30076 9.55065 2.11742 9.29232 2.38409L6.95898 4.70909C6.79232 4.87576 6.79232 5.13409 6.95898 5.30076L9.28398 7.62576C9.55065 7.88409 10.0007 7.70076 10.0007 7.32576V5.83409C12.759 5.83409 15.0007 8.07576 15.0007 10.8341C15.0007 13.1008 13.4757 15.0174 11.409 15.6258C11.059 15.7258 10.834 16.0591 10.834 16.4174C10.834 16.9591 11.3507 17.3841 11.8757 17.2258C14.6423 16.4174 16.6673 13.8674 16.6673 10.8341C16.6673 7.15076 13.684 4.16742 10.0007 4.16742Z",
    fill: "#6148f6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.00065 10.8324C5.00065 9.71576 5.36732 8.68243 5.99232 7.84076C6.24232 7.50743 6.20898 7.0491 5.91732 6.7491C5.56732 6.3991 4.96732 6.43243 4.66732 6.83243C3.83398 7.9491 3.33398 9.33243 3.33398 10.8324C3.33398 13.8658 5.35898 16.4158 8.12565 17.2241C8.65065 17.3824 9.16732 16.9574 9.16732 16.4158C9.16732 16.0574 8.94232 15.7241 8.59232 15.6241C6.52565 15.0158 5.00065 13.0991 5.00065 10.8324Z",
    fill: "#6148f6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8297_44112"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetIcon);
export default __webpack_public_path__ + "static/media/resetIcon.0bda5cd93953d5b3f833377cf4520455.svg";
export { ForwardRef as ReactComponent };